import { InfluencerWhitelist } from '@anytag/graphql';
import { ListWithPagination } from '@anytag/shared-molecules';
import {
  MarketplaceInfluencersSort,
  MarketplaceInfluencersList,
  MarketplaceInfluencersFilter
} from '@anytag/shared-organisms';
import { useMarketplaceInfluencersList } from '../hooks';
import { useMarketplaceDetailsContext } from '../../marketplace-details-context';
import { useMarketplaceInfluencersSelectButtonsProps } from './hooks';
import { ConfirmInfluencersParticipateCampaignModal } from './confirm-influencers-participate-campaign-modal';
import { ConfirmMarkInfluencersAsAvailableModal } from './confirm-mark-influencers-as-available-modal';

export interface MarketplaceInfluencersForAdminStaffProps {
  influencerWhitelist: InfluencerWhitelist;
}

// This is an advanced Select Influencers tab, replace for current Select influencers tab if `forceInfluencersParticipateCampaign: true`
// Condition for `forceInfluencersParticipateCampaign` can be changed sometimes, please find that variables to see the condition
export const MarketplaceInfluencersForAdminStaff = ({
  influencerWhitelist
}: MarketplaceInfluencersForAdminStaffProps) => {
  const { marketplace } = useMarketplaceDetailsContext();
  const { fetchingInfluencersList, listInfluencers, totalRecords } = useMarketplaceInfluencersList();
  const {
    markAsJoinedModal,
    markAsAvailableModal,
    sortSelectButtonProps,
    generateListSelectButtonProps,
    selectedJoinableInfluencerIds,
    selectedUnavailableInfluencerIds,
    resetSelectedJoinableInfluencerIds,
    resetSelectedUnavailableInfluencerIds
  } = useMarketplaceInfluencersSelectButtonsProps({ totalRecords, listInfluencers, influencerWhitelist });

  return (
    <>
      <ListWithPagination pagination={{ totalRecords }}>
        <MarketplaceInfluencersFilter marketplace={marketplace} />
        <MarketplaceInfluencersSort selectButtonProps={sortSelectButtonProps} />

        <MarketplaceInfluencersList
          data={listInfluencers}
          totalRecords={totalRecords}
          loading={fetchingInfluencersList}
          generateSelectButtonProps={generateListSelectButtonProps}
        />
      </ListWithPagination>

      <ConfirmInfluencersParticipateCampaignModal
        open={markAsJoinedModal.status}
        onClose={markAsJoinedModal.close}
        selectedInfluencerIds={selectedJoinableInfluencerIds}
        resetSelectedInfluencerIds={resetSelectedJoinableInfluencerIds}
      />

      <ConfirmMarkInfluencersAsAvailableModal
        open={markAsAvailableModal.status}
        onClose={markAsAvailableModal.close}
        selectedInfluencerIds={selectedUnavailableInfluencerIds}
        resetSelectedInfluencerIds={resetSelectedUnavailableInfluencerIds}
      />
    </>
  );
};
